export default __webpack_public_path__ + "static/media/ServiceLandingPage.b2005010.jpeg";